export const RESUME_LINK = 'https://dgr8akki.github.io/resume/AakashPahujaResume.pdf';
